import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { COOKIE_KEY } from "@/lib/legal";

const HIDDEN = ["/admin", "/sign-in", "/sign-up"];

export default function CookieBanner() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => !localStorage.getItem(COOKIE_KEY));

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("esc-open-cookies", show);
    return () => window.removeEventListener("esc-open-cookies", show);
  }, []);

  const choose = (value) => {
    const prev = localStorage.getItem(COOKIE_KEY);
    localStorage.setItem(COOKIE_KEY, value);
    setOpen(false);
    if (value === "all") window.__escInitAnalytics?.();
    else if (prev === "all") window.location.reload();
  };

  if (!open || HIDDEN.some((p) => pathname.startsWith(p))) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[120] mx-auto max-w-3xl rise" data-testid="cookie-banner">
      <div className="flex flex-col gap-4 rounded-3xl border border-white/10 bg-[#1A152E]/95 p-5 shadow-2xl backdrop-blur-xl md:flex-row md:items-center">
        <Cookie className="hidden h-8 w-8 shrink-0 text-[#FFD600] md:block" />
        <p className="text-sm leading-relaxed text-muted-foreground">
          A működéshez szükséges tárolást (korhatár- és süti-választás, admin belépés) mindig használjuk. Látogatási statisztikát
          (PostHog, munkamenet-rögzítéssel) csak a hozzájárulásoddal indítunk. Részletek az{" "}
          <Link to="/adatvedelem#sutik" className="font-semibold text-white underline">adatkezelési tájékoztatóban</Link>.
        </p>
        <div className="flex shrink-0 gap-2">
          <button onClick={() => choose("necessary")} data-testid="cookie-necessary-button"
            className="rounded-full border border-white/15 px-4 py-2.5 text-sm font-semibold transition-colors hover:bg-white/5">Csak szükséges</button>
          <button onClick={() => choose("all")} data-testid="cookie-accept-all-button"
            className="rounded-full bg-[#FF3B6C] px-4 py-2.5 text-sm font-bold text-white transition-transform hover:scale-105">Elfogadom mind</button>
        </div>
      </div>
    </div>
  );
}
